module.exports = "https://vote4-campaigns-cdn.fire-emblem-heroes.com/images/src/assets/images/series/ja-JP/img_series-110.png";